module.exports = __webpack_public_path__ + "img/H-Tomaia180_ok.0724655d.png";